/**
 * PageHeader / StatChips ortak renk token'lari.
 *
 * Ayri dosyada: StatChips PageHeader'dan cikarilinca ikisi de ayni haritayi
 * kullanmak zorunda kaldi; PageHeader'dan import etmek dairesel bagimlilik
 * uretiyordu (PageHeader -> StatChips -> PageHeader).
 *
 * Hardcoded hex yalnizca `loader` alanindadir — react-loader-spinner CSS
 * class degil, `color` prop'u aliyor (bkz. docs/rules/styling.md).
 */
const COLOR_MAP = {
  indigo: {
    gradient: "from-indigo-50 to-purple-50",
    border: "border-indigo-100",
    icon: "text-indigo-600",
    statBg: "bg-indigo-50/80",
    statBorder: "border-indigo-100/80",
    statIcon: "text-indigo-500",
    statValue: "text-indigo-800",
    statLabel: "text-indigo-500",
    loader: "#4F46E5",
  },
  emerald: {
    gradient: "from-emerald-50 to-green-50",
    border: "border-emerald-100",
    icon: "text-emerald-600",
    statBg: "bg-emerald-50/80",
    statBorder: "border-emerald-100/80",
    statIcon: "text-emerald-500",
    statValue: "text-emerald-800",
    statLabel: "text-emerald-500",
    loader: "#059669",
  },
  amber: {
    gradient: "from-amber-50 to-yellow-50",
    border: "border-amber-100",
    icon: "text-amber-600",
    statBg: "bg-amber-50/80",
    statBorder: "border-amber-100/80",
    statIcon: "text-amber-500",
    statValue: "text-amber-800",
    statLabel: "text-amber-500",
    loader: "#D97706",
  },
  blue: {
    gradient: "from-blue-50 to-indigo-50",
    border: "border-blue-100",
    icon: "text-blue-600",
    statBg: "bg-blue-50/80",
    statBorder: "border-blue-100/80",
    statIcon: "text-blue-500",
    statValue: "text-blue-800",
    statLabel: "text-blue-500",
    loader: "#2563EB",
  },
  green: {
    statBg: "bg-green-50/80",
    statBorder: "border-green-100/80",
    statIcon: "text-green-500",
    statValue: "text-green-800",
    statLabel: "text-green-500",
    loader: "#16A34A",
  },
  // Uyarılar sayfası "Kritik" sayacı (#229)
  red: {
    gradient: "from-red-50 to-rose-50",
    border: "border-red-100",
    icon: "text-red-600",
    statBg: "bg-red-50/80",
    statBorder: "border-red-100/80",
    statIcon: "text-red-500",
    statValue: "text-red-800",
    statLabel: "text-red-500",
    loader: "#DC2626",
  },
};

export function getStatColorTokens(color) {
  return COLOR_MAP[color] || COLOR_MAP.indigo;
}
